import { render, staticRenderFns } from "./mediaRejectBanner.vue?vue&type=template&id=dea176be&scoped=true&"
import script from "./mediaRejectBanner.vue?vue&type=script&lang=js&"
export * from "./mediaRejectBanner.vue?vue&type=script&lang=js&"
import style0 from "./mediaRejectBanner.vue?vue&type=style&index=0&id=dea176be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea176be",
  null
  
)

export default component.exports